// removed by extract-text-webpack-plugin
module.exports = {"vpQuestionPreviewTitle":"vpQuestionPreviewTitle___3MGwu","vpTogglePreview":"vpTogglePreview___2Ivj3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/QuestionPreview.module.less
// module id = 2559
// module chunks = 29